import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_NEW_ADDRESS: MijnRoute = {
    path: 'bouwdepot/adres-nieuwe-woning-doorgeven',
    navigationEvent: 'toBouwdepotAdresNieuweWoningDoorgeven',
    regex: /^\/hypotheek\/bouwdepot\/adres-nieuwe-woning-doorgeven$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'beeindigen'
};
